<template>
    <div class="FM_financial">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="financeRecordForm" class="demo-form-inline">
                <el-form-item v-if="isedit<=1">
                    <el-select
                            v-model="financeRecordForm.parent_id"
                            filterable
                            clearable
                            style="width:100%"
                            placeholder="请选择归属机构"
                    >
                        <el-option
                                v-for="(item,index) in parentList"
                                :key="index"
                                :label="item.name_phone"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                            v-model="financeRecordForm.brand_id"
                            filterable
                            clearable
                            style="width:100%"
                            placeholder="请选择终端类型"
                    >
                        <el-option
                                v-for="(item,index) in brandList"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <!--                <el-form-item>-->
                <!--                    <el-select-->
                <!--                            size-->
                <!--                            v-model="financeRecordForm.income_type"-->
                <!--                            clearable-->
                <!--                            placeholder="请选择入账类型">-->
                <!--                        <el-option label="押金扣款收入" value="12"></el-option>-->
                <!--                        <el-option label="流量卡扣款收入" value="19"></el-option>-->
                <!--                        <el-option label="伪激活扣款收入" value="10"></el-option>-->
                <!--                        <el-option label="未激活扣款收入" value="20"></el-option>-->
                <!--                        <el-option label="货款分期收入" value="14"></el-option>-->
                <!--                        <el-option label="代理提现" value="1"></el-option>-->
                <!--                        <el-option label="伪激活扣款[提现]" value="10"></el-option>-->
                <!--                        <el-option label="未激活扣款[提现]" value="20"></el-option>-->
                <!--                        <el-option label="货款分期[提现]" value="13"></el-option>-->
                <!--                    </el-select>-->
                <!--                </el-form-item>-->
                <el-form-item>
                    <el-select
                            size
                            v-model="financeRecordForm.balance_type"
                            clearable
                            placeholder="类型">
                        <el-option label="收入" value="1"></el-option>
                        <el-option label="支出" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isedit<=1">
                    <el-input clearable v-model="financeRecordForm.phone" placeholder="请输入归属代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                            v-model="rangeDate"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="交易开始日期"
                            end-placeholder="交易结束日期"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="onSearch(financeRecordForm)"
                    >查询</el-button>
<!--                    <el-button-->
<!--                            v-if="isedit<=1"-->
<!--                            size="small"-->
<!--                            type="primary"-->
<!--                            icon="el-icon-download"-->
<!--                            :loading="downLoading"-->
<!--                            @click="handleDownLoad()"-->
<!--                    >导出数据</el-button>-->
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="financeRecordTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
                    :cell-style="changeCellStyle"
            >
                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 所属终端类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="type"
                        label="交易类型"
                        min-width="150"
                ></el-table-column>
                <!-- 所属终端类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="brand_name"
                        label="所属终端类型"
                        min-width="120"
                ></el-table-column>
                <!-- 终端号 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="terminal_sn"
                        label="终端号"
                        min-width="200"
                ></el-table-column>
                <!-- 类型 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="balance_types"
                        label="类型"
                        min-width="120"
                ></el-table-column>
                <!-- 金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="money"
                        label="金额"
                        min-width="120"
                ></el-table-column>
                <!-- 余额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="balance"
                        label="余额"
                        min-width="80"
                ></el-table-column>
                <!-- 入账时间 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="time"
                        label="交易时间"
                        min-width="180"
                ></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                    :currentPage="page.currentPage"
                    :pageSize="page.pageSize"
                    :total="page.total"
                    @watchCurrent="getCurrent"
                    @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "FM_agentaccountList",
    data() {
        return {
            isedit: sessionStorage.getItem('level'), //等级
            currentDate: '',
            pickerOptions: {},
            rangeDate: [], //时间范围
            financeRecordTable: [], //表格
            brandList: [], //终端类型
            parentList: [], //终端类型
            financeRecordForm: {
                phone: '', //用户账户
                start_time: '',    //申请开始时间
                end_time: '',    //申请结束时间
                type: this.$route.query.type,
                income_type:'',
                brand_id: '', //终端类型
                parent_id: '', //终端类型
                page: 1,
                limit: 10,
                balance_type:'' //类型
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            downLoading: false, //导出loading
            type: '',
            total_money: 0,
            fee_money:0,
            tax_money:0,
        }
    },
    mounted() {
        this.getData(this.financeRecordForm);
        this.getBrand();//获取终端类型
        this.getParent();//获取终端类型
    },
    created() {
        this.pickerOptions.disabledDate = (time) => { //禁用日期
            if (this.currentDate !== '') {
                let tempTime = 3600 * 1000 * 24 * 30;
                let timer = new Date(this.currentDate).getTime();
                let minTime = timer - tempTime;
                let maxTime = timer + tempTime;
                return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
            }
            return time.getTime() > Date.now();
        }
        this.pickerOptions.onPick = ({ minDate, maxDate }) => { //当前选中的日期
            this.currentDate = minDate.getTime();
            if (maxDate) {
                this.currentDate = '';
            }
        }
    },
    components: {
        paginations
    },
    methods: {
        onSearch(financeRecordForm) {
            this.page.currentPage = 1;
            this.financeRecordForm.page = 1;
            // 表单提交
            this.getData(financeRecordForm);
        },
        //分页
        getCurrent(page) {
            this.loading = true;
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.financeRecordForm.page = this.page.currentPage;
            this.financeRecordForm.limit = this.page.pageSize;
            this.getData(this.financeRecordForm);
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.financeRecordForm.page = this.page.currentPage;
            this.financeRecordForm.limit = limit;
            this.getData(this.financeRecordForm);
        },
        getData(params) {
            this.$api.post("user/agent_account_profit_all_list", params, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.financeRecordTable = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        // handleDownLoad() { //导出
        //     this.downLoading = true;
        //     this.$api.post("user/agent_account_list_download", this.financeRecordForm, res => {
        //         if (res.code == 0) {
        //             this.$message.success(res.msg);
        //             var link=this.$file_url+res.data;
        //             window.open(link)
        //         } else {
        //             this.$message.error(res.msg);
        //         }
        //         //渲染结束后取消加载
        //         this.downLoading = false;
        //     })
        // },
        getBrand() { //获取终端类型
            this.$api.post('brand/brand_list', {}, res => {
                if (res.code == 0) {
                    this.brandList = res.data.list;
                } else {
                    this.$message.success(res.msg);
                }
            });
        },
        getParent() { //获取终端类型
            this.$api.post('user/list_by_id', {}, res => {
                if (res.code == 0) {
                    this.parentList = res.data.list;
                } else {
                    this.$message.success(res.msg);
                }
            });
        },
        pickerChange(DateArr) { //时间选择器
            this.financeRecordForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.financeRecordForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.financeRecordForm.start_time, this.financeRecordForm.end_time];
        },
        changeCellStyle({row}) {
            if(row.balance_type == 1 )
            {
                return 'color: red;'
            }else{
                return 'color: green;'
            }
        }
    }
};
</script>

<style lang="scss" scope>
.FM_financial {
  .realTitle {
    :nth-child(1) {
      font-size: 12px;
      font-weight: 700;
      color: #1e1e1e;
    }
    .imgParent {
      margin: 10px 0;
      // width: 500px;
      overflow: hidden;
      img {
        width: 100%;
        height: 250px;
        border-radius: 10px;
      }
    }
  }
  .el-dialog__header {
    padding: 20px 20px 0px;
  }
  .el-dialog__body {
    padding: 0px 20px 30px 20px;
  }
  .el-input__inner {
    font-size: 12px;
  }
  .el-form-item {
    margin-bottom: 5px;
  }
}
</style>
